module.exports = __webpack_public_path__ + "img/email_not_updated_light.be63616a.svg";